<div class="table-container">
    <div class="container-flex">
        <div class="container-item-1"></div>
        <div class="container-item-2">Total</div>
        <ng-container *ngFor="let status of totalStatusByPeriod; index as j">
            <div class="container-item-1">
                <p class="sub-item-1">{{ status.statusName }}</p>
            </div>
            <div class="container-item-2">{{ status.statusAtPercentage }}%</div>
        </ng-container>
    </div>
    <div class="table-status-park">
        <table class="table-main" aria-label="table-status-park">
            <thead>
                <tr>
                    <th
                        scope="col"
                        class="periods"
                        *ngFor="let range of periodArray"
                    >
                        <div>{{ range.periodStartTime | date: "HH:mm" }}</div>
                        <div>{{ range.periodEndTime | date: "HH:mm" }}</div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let status of totalStatusByPeriod; index as j">
                    <td class="loops-machine"
                        *ngFor="let porcentage of status.porcentageByStatus"
                        [ngClass]="{ odd: j % 2 !== 0, even: j % 2 === 0 }"
                    >
                        <div class="loops" >
                            {{ porcentage.statusAtPercentage}}%
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
